// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 *
 * UMD header generated via modularize.js at 2015-04-09T01:32:08.701Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:vendor/jquery-1.9.1.min': '$',
  'templito:image_upload': []
})(this, function (m_module, Backbone, _, $) {
"use strict";

var M = m_module.M;

  /**
   * @class M.View.EditableImageSimple
   *
   * Represents an editable image area with upload capabilities
   * supported through jQuery uploader
   *
   * - Requires jquery.fileupload.js; Note - tried to put this file and
   *   jquery.fileupload.js in base_new.js but there was some conflict
   * - Takes the height and width of parent container and sets image
   * dimensions as such
   * - Error messages are appended to the parent element
   * - Triggers assetUploadSuccess event on sucessful asset upload
   * - actual and display dimensions -- a 10000 x 10000 image may
   *   need to fit in 100x100 div so we track both dimensions
   *
   * Arguments
   * - displayHeight: int - display height of the image area
   * - displayWidth: int - display width of the image area
   * - imageHeight: int - actual height of image file
   * - imageWidth: int - actual width of image file
   * - url: string - path to update endpoint
   *   (e.g. '/designer/update_photo')
   * - assetId: string - id of asset for coordination with backend,
   *   also passed as data with assetUploadSuccess event on asset save
   * - imgUrl: string - path to image url if image already exists and
   *   loading in 'edit' mode, can be undefined
   *
   * Endpoint requirements:
   * - Needs to return json with attributes formatted as:
   *   {
   *     'status': ['success'|'error'],
   *   }
   */
  M.View.EditableImageSimple = Backbone.View.extend({
    tagName: 'div',
    className: 'editableImage',

    template: M.Template.ImageUpload.EditableImageSimple,

    events: {
      'mouseenter': 'onMouseEnter',
      'mouseleave': 'onMouseLeave',
      'click .imageChangeButton': 'handleChangeImage',
      'click .imageDeleteButton': 'handleDeleteImage',
      'click .imagePromptTextBlock': 'handleChangeImage'
    },

    initialize: function() {
      this.$el = $(this.el);
    },

    render: function() {
      var that = this;
      var html = this.template({
        displayHeight: this.options.displayHeight,
        displayWidth: this.options.displayWidth,
        imageHeight: this.options.imageHeight,
        imageWidth: this.options.imageWidth,
        imgUrl: this.options.imgUrl, // can be undefined,
        disableEdit: this.options.disableEdit,
        disabledEditExplanationText: this.options.disabledEditExplanationText
      });
      this.$el.empty();
      this.$el.append(html);

      this.$el.css({
        'width': parseInt(this.options.displayWidth, 10) + 'px',
        'height': parseInt(this.options.displayHeight, 10) + 'px'
      });

      // Center text and change button
      this.centerElements();

      // Attach jquery fileupload
      var formData = {
        'required_height': this.options.imageHeight,
        'required_width': this.options.imageWidth,
        'asset_id': this.options.assetId,
        'designer_user_id': this.options.uid
      };

      // Can't do file type checking as we're not using UI version of
      // plugin so validation is on backend
      this.$el.find('.fileupload').fileupload({
        dataType: 'json',
        singleFileUploads: true,
        paramName: 'imageFile',
        type: 'POST',
        url: this.options.url,
        formData: formData,
        done: function(e, data) {
          // clear any existing error message
          that.clearErrorMsg(that.$el.parent());
          // process response
          if (data.result['status'] === 'Error') {
            that.appendErrorMsg(that.$el.parent(),
              that.getErrorMsgElement(data.result['user_msg']));
          } else {
            // success, so display the new image url
            // if the new image url is the same as the old one, the image will
            // not refresh. We append a querystring to force a refresh.
            var imgUrl = data.result['image_url'] + '?' + Date.now();
            that.$el.find('.imageAsset').attr('src', imgUrl);
            that.$el.find('.imagePromptTextBlock').hide();
            that.$el.trigger('assetUploadSuccess', that.options.assetId);
          }
        },
        fail: function(e, data) {
          alert('An error occurred while uploading your file. ' +
            'Please try again.');
        }
      });
      return this;
    },

    onMouseEnter: function() {
      if (this.options.disableEdit) {
        if (this.options.disabledEditExplanationText) {
        this.$el.find('.disabledEditExplanationText').show();
        }
      } else if (this.options.deleteUrl) {
        // show both the delete button and change button
        this.$el.find('.imageDeleteButton').css('display', 'inline-block');
        this.$el.find('.imageChangeButton').css('display', 'inline-block');
      } else {
        // show just the change button
        this.$el.find('.imageChangeButton').css('display', 'inline-block');
      }
    },

    onMouseLeave: function() {
      if (this.options.disableEdit) {
        if (this.options.disabledEditExplanationText) {
        this.$el.find('.disabledEditExplanationText').hide();
        }
      } else if (this.options.deleteUrl) {
        this.$el.find('.imageDeleteButton').hide();
      }
      this.$el.find('.imageChangeButton').hide();
    },

    handleChangeImage: function() {
      this.$el.find('.fileupload').trigger('click');
    },

    handleDeleteImage: function() {
      var dialogContainer = this.$el.find('.deleteDialog');
      dialogContainer.dialog({
        title: 'Reason for Deletion',
        width: 400,
        draggable: false,
        modal: true,
        closeOnEscape: true
      });
      this.handleDeleteDialogCloseClick(dialogContainer);
      this.handleDeleteReasonClick(dialogContainer);
    },

    handleDeleteDialogCloseClick: function(dialogContainer) {
      $('.ui-dialog-titlebar-close').click(function() {
        dialogContainer.dialog('destroy');
      });
    },

    // NB: the data-attrs on the template must correspond to the deleteReasons
    // sent from the backend.
    handleDeleteReasonClick: function(dialogContainer) {
      var that = this;
      var clicked = false;

      $('.deleteDialogButton').each(function() {
        $(this).click(function() {
          if (!clicked) {
            clicked = true;
            dialogContainer.dialog('close');
            $('.deleteDialogWarning').empty();
            var reasonIndex = $(this).attr('data-reasonIndex');
            that.deleteImage(that.options.deleteReasons[reasonIndex]);
          }
        });
      });
    },

    deleteImage: function(reason) {
      $.ajax({
        method: 'POST',
        url: this.options.deleteUrl,
        data: {
          'designerUserId': this.options.uid,
          'reason': reason
        },
        success: this.resetImage.bind(this)
      });
    },

    // removes references to the image and re-renders
    resetImage: function() {
      this.options.imgUrl = '';
      this.options.deleteUrl = '';
      this.render();
    },

    getErrorMsgElement: function(errorMsg) {
      return '<div class="editableImgError warning">' + errorMsg + '</div>';
    },

    appendErrorMsg: function(parentElement, errorMsgElement) {
      // Appends error message to parent element that's specified
      parentElement.append(errorMsgElement);
    },

    clearErrorMsg: function(parentElement) {
      // Clear parent element
      var errorElement = parentElement.find('.editableImgError');
      if (errorElement.length) {
        errorElement.remove();
      }
    },

    /**
     * Dynamically centers text and buttons that need to be vertically
     *   centered.
     */
    centerElements: function() {
      // Height of elements in px - measured, but ideally should be calculated
      var imageBlockHeight = this.options.displayHeight;

      // Center upload text
      var imageTextTopMargin = Math.floor(
        (imageBlockHeight - M.View.EditableImageSimple.IMAGE_TEXT_HEIGHT) / 2);

      this.$el.find('.addImageText').css(
        {'margin-top': imageTextTopMargin.toString() + 'px'});

      // Center change button if the delete button does not exist
      // Center image change button, image delete button
      if (!this.options.deleteUrl) {
        var imageButtonTopMargin = Math.floor(
          (imageBlockHeight - M.View.EditableImageSimple.IMAGE_BUTTON_HEIGHT) / 2);
        this.$el.find('.imageChangeButton').css(
          {'margin-top': imageButtonTopMargin.toString() + 'px'});
      }
    }
  }, {
    IMAGE_TEXT_HEIGHT: 70,
    IMAGE_BUTTON_HEIGHT: 30
  });

return {
  EditableImageSimple: M.View.EditableImageSimple
};

});